import { render, staticRenderFns } from "./blueprint-badge.vue?vue&type=template&id=098f3254&scoped=true&"
import script from "./blueprint-badge.vue?vue&type=script&lang=ts&"
export * from "./blueprint-badge.vue?vue&type=script&lang=ts&"
import style0 from "./blueprint-badge.vue?vue&type=style&index=0&id=098f3254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f3254",
  null
  
)

export default component.exports